import {logTypes, allLogTypes} from './constants';
import {default as createLogContext} from './createLogContext';
import {default as shouldLog} from './shouldLog';
import {default as observe} from './observe';
import {default as notifyLogObservers} from './notifyLogObservers';

globalThis.nowUiFrameworkLogs = {
	observe,
	logTypes
};

export {shouldLog, observe, createLogContext, notifyLogObservers, allLogTypes};
